import gsap from "gsap";

export class MobileMenu {
	constructor() {
		this.mobileMenu = document.querySelector(".mobile-menu");

		if (!this.mobileMenu) {
			return;
		}

		this.toggle = document.querySelector(".mobile-menu__toggle");
		this.overlay = document.querySelector(".mobile-menu__overlay");
		this.menuItems = document.querySelectorAll(".mobile-menu__list-item");
		this.contactButton = document.querySelector(".mobile-menu__contact-button");

		this.addEventListeners();
	}

	addEventListeners() {
		this.toggle.addEventListener("click", () => {
			if (this.toggle.getAttribute("aria-expanded") === "true") {
				this.close();
			} else {
				this.open();
			}
		});
	}

	open() {
		if (this.toggle.getAttribute("aria-expanded") === "true") {
			return;
		}

		this.toggle.setAttribute("aria-expanded", "true");

		gsap.set(this.overlay, {
			autoAlpha: 1,
			yPercent: -100,
		});

		gsap.set(this.menuItems, {
			autoAlpha: 0,
			y: 20,
		});

		gsap.set(this.contactButton, {
			autoAlpha: 0,
		});

		const toggleAnimation = gsap
			.timeline({
				defaults: {
					duration: 0.25,
					ease: "power4.out",
				},
			})

			.to(
				this.toggle.querySelector("path:nth-child(1)"),
				{
					y: 6.5,
				},
				"<"
			)

			.to(
				this.toggle.querySelector("path:nth-child(3)"),
				{
					y: -6.5,
				},
				"<"
			)

			.set(
				this.toggle.querySelector("path:nth-child(2)"),
				{
					opacity: 0,
				},
				"<"
			)

			.to(this.toggle.querySelector("path:nth-child(1)"), {
				rotation: 45,
				transformOrigin: "50% 50%",
			})

			.to(
				this.toggle.querySelector("path:nth-child(3)"),
				{
					rotation: -45,
					transformOrigin: "50% 50%",
				},
				"<"
			);

		const overlayAnimation = gsap
			.timeline({
				defaults: {
					duration: 0.5,
					ease: "power1.out",
				},
			})
			.to(this.overlay, {
				yPercent: 0,
			})
			.to(this.menuItems, {
				autoAlpha: 1,
				y: 0,
			})
			.to(
				this.contactButton,
				{
					autoAlpha: 1,
				},
				"<"
			);
	}

	close() {
		if (this.toggle.getAttribute("aria-expanded") === "false") {
			return;
		}

		const toggleAnimation = gsap
			.timeline({
				defaults: {
					duration: 0.25,
					ease: "power4.out",
				},
			})

			.to(this.toggle.querySelector("path:nth-child(1)"), {
				rotation: 0,
			})

			.to(
				this.toggle.querySelector("path:nth-child(3)"),
				{
					rotation: 0,
				},
				"<"
			)

			.set(
				this.toggle.querySelector("path:nth-child(2)"),
				{
					opacity: 1,
				},
				"<"
			)

			.to(this.toggle.querySelector("path:nth-child(1)"), {
				y: 0,
			})

			.to(
				this.toggle.querySelector("path:nth-child(3)"),
				{
					y: 0,
				},
				"<"
			);

		const overlayAnimation = gsap
			.timeline({
				defaults: {
					duration: 0.5,
					ease: "power1.out",
				},
			})
			.to(this.menuItems, {
				autoAlpha: 0,
				y: 20,
			})
			.to(
				this.contactButton,
				{
					autoAlpha: 0,
				},
				"<"
			)
			.to(this.overlay, {
				yPercent: -100,
			})
			.call(
				() => {
					this.toggle.setAttribute("aria-expanded", "false");
				},
				[],
				"-=0.25"
			);
	}
}
